module.exports = __webpack_public_path__ + "static/media/0103_Medium.1235e184.jpg";